module.exports = __webpack_public_path__ + "static/food-and-drinks-0e50b519d86ab1df816a4a60cdc01f2f.png";